import React from 'react';
import styles from './HowItWorks.module.scss';
import stepWelcome from '../../../assets/images/icon-1.svg';
import stepChecked from '../../../assets/images/icon-2.svg';
import stepYourDetails from '../../../assets/images/icon-3.svg';
import stepSelect from '../../../assets/images/icon-4.svg';
import stepNotified from '../../../assets/images/icon-5.svg';
import ScrollIndicator from './ScrollIndicator';

const HowItWorks = () => {
  const target = React.createRef();
  return (
    <section>
      <div className={`${styles.howToUse}`}>
        <div className={`container`}>
          <div className={`row`}>
            <div className={`col-12 `}>
              <h3>
                How to use this service:
                <div className={`${styles.iconScroll} d-lg-none`}></div>
              </h3>
              <div
                className={`hor-scrollable ${styles.horScrollable} ${styles.scrollbarHidden}`}
                ref={target}
              >
                <ol className={styles.stepProgressList}>
                  <li>
                    <img alt="Icon: welcome" src={stepWelcome} />
                    <span className={styles.stepTitle}>
                      Enter details of the person who has died
                    </span>
                    <span className={styles.numbers}>1</span>
                  </li>
                  <li>
                    <img alt="Icon: your input is being verified" src={stepChecked} />
                    <span className={styles.stepTitle}>
                      Details are checked to confirm death is registered
                    </span>
                    <span className={styles.numbers}>2</span>
                  </li>
                  <li>
                    <img alt="Icon: enter your details" src={stepYourDetails} />
                    <span className={styles.stepTitle}>
                      Find organisations to notify and enter account numbers
                    </span>
                    <span className={styles.numbers}>3</span>
                  </li>
                  <li>
                    <img alt="Icon: select organisations to notify" src={stepSelect} />
                    <span className={styles.stepTitle}>Enter your details as the notifier</span>
                    <span className={styles.numbers}>4</span>
                  </li>
                  <li>
                    <img alt="Icon: your request has been sent" src={stepNotified} />
                    <span className={styles.stepTitle}>
                      Organisations will make contact with you
                    </span>
                    <span className={styles.numbers}>5</span>
                  </li>
                </ol>
              </div>
              <ScrollIndicator count={5} target={target}></ScrollIndicator>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
